<template>
    <div ref="chart" style="width: 100%; height: 100%;"></div>
  </template>
  
  <script>
  
  export default {
    name: 'LineChart',
    props: {
      chartData: {
        type: Array,
        required: true
      },
      // serviceDate: {
      //   type: Object,
      //   default: () => ({})
      // },
      optionNum:{
        type:Number
      }
    },
    data() {
      return {
        chartInstance: null,
      };
    },
    mounted() {
      this.initChart();
    },
    beforeDestroy() {
      if (this.chartInstance) {
        this.chartInstance.dispose();
      }
    },
    watch: {
      chartData: {
        deep: true,
        handler() {
          this.updateChart();
        }
      },
      optionNum: {
        deep: true,
        handler(newVal) {
          // console.log(newVal)
          this.updateChart();
        }
      },
    },
    methods: {
      initChart() {
        this.chartInstance = this.$echarts.init(this.$refs.chart);
        this.updateChart();
      },
      updateChart() {
        if (!this.chartInstance) return;
        let that = this
        // console.log('eeeeeee',this.chartData)
        let markIndex = 0
        let len = this.chartData.length-1
        let maxNum = this.chartData[len]
        if(that.optionNum==1){
          markIndex = 0
        }else if(that.optionNum>=maxNum){
          markIndex = len
        }else{
          markIndex = this.chartData.indexOf(that.optionNum)
        }
        // console.log(markIndex)
        const option = {
          
          tooltip: {
            trigger: 'axis',
            formatter: params => {
              return `Monthly Impressions: ${params[0].value.toLocaleString()}`;
            }
          },
          grid: {
            left: '3%',
              right: '4%',
              bottom: '3%',
              top: '15%',
              containLabel: true,
              show: true,
              borderColor: '#eee',
              backgroundColor: '#fff'
          },
          xAxis: {
            type: 'category',
            data: this.chartData,
              boundaryGap: false,
              axisLine: {
                lineStyle: {
                  color: '#999'
                }
              },
              axisTick: {
                alignWithLabel: true
              },
              axisLabel: { show: false },   // 隐藏刻度标签
              splitLine: {
                show: true,
                lineStyle: {
                  color: ['#eee'],
                  type: 'dashed'
                }
              }
          },
          yAxis: {
            type: this.useLogScale ? 'log' : 'value',
            // name: '数值',
            nameLocation: 'end',
            logBase: 10,
            axisLine: {
              show: true,
              lineStyle: {
                color: '#999'
              }
            },
            axisLabel: {
              formatter: value => {
                if (value >= 1000000) return `${value/1000000}M`;
                if (value >= 1000) return `${value/1000}K`;
                return value;
              }
            },
            splitLine: {
              show: true,
              lineStyle: {
                type: 'dashed',
                color: '#eee'
              }
            },
            
          },
          series: [{
            name: '增长趋势',
            type: 'line',
            data: this.chartData,
            symbol: 'circle',
            symbolSize: function(value, params) {
                // 只在特定条件下显示点(这里显示值为230的点)
                return value == that.optionNum ? 6 : 0;
            },
            itemStyle: {
                color: '#FEAE00', // 填充颜色
                borderColor: '#FEAE00', // 边框颜色
                borderWidth: 2,   // 边框宽度
                opacity: 1        // 不透明度
            },
            smooth: true,
            lineStyle: {
              width: 2,
            },
            areaStyle: {
              color: {
                  type: 'linear',
                  x: 0,
                  y: 0,
                  x2: 0,
                  y2: 1,
                  colorStops: [
                  { offset: 0, color: 'rgba(254, 174, 0, 0.4)' },
                  // { offset: 0.5, color: 'rgba(255, 255, 0, 0.5)' },
                  { offset: 1, color: 'rgba(255, 255, 255, 0)'}
                  ],
                  global: false
              }
            },
            
            // 标记线（竖线）
          markLine: {
            symbol: 'none',
            lineStyle: {
              type: 'solid',
              color: '#EE6666',
              width: 2
            },
            label: {
              show: false
            },
            data: [{
              xAxis: markIndex,  // 在指定索引位置画竖线
              lineStyle: {
                type: 'dashed'
              }
            }]
          },
            // label: {
            //   show: true,
            //   position: 'top',
            //   formatter: params => {
            //     return params.value.toLocaleString();
            //   }
            // },
          }],
        };
        this.chartInstance.setOption(option,true);
      
      
        // 响应式调整
        window.addEventListener('resize', this.handleResize);
      },
      handleResize() {
        if (this.chartInstance) {
          this.chartInstance.resize();
        }
      }
    }
  };
  </script>